import React from "react";
import { Typography, Box } from "@mui/material";
import { Vocabulary } from "../../Utils/Vocabulary";
import { ContractData } from "../ProductSettings/Types/Types";

interface ContractSampleProps {
  contractData: ContractData;
  handleFieldChange: (field: keyof ContractData, value: string) => void;
}

export const ServiceContractSample: React.FC<ContractSampleProps> = ({
  contractData,
  handleFieldChange,
}) => {
  return (
    <>
      <Box mt={4}>
        <Typography variant="h6" gutterBottom>
          <strong>{Vocabulary.contractArticle1Title}</strong>
        </Typography>
        <Typography variant="body1" paragraph>
          {Vocabulary.contractArticle1Text}
        </Typography>

        <Typography variant="h6" gutterBottom>
          <strong>{Vocabulary.contractArticle2Title}</strong>
        </Typography>
        <Typography variant="body1" paragraph>
          {Vocabulary.contractArticle2Text
            .split("\n")
            .map((line: number, index: number) => (
              <React.Fragment key={index}>
                {line}
                {index <
                  Vocabulary.contractArticle2Text.split("\n").length - 1 && (
                    <br />
                  )}
              </React.Fragment>
            ))}
        </Typography>

        <Typography variant="h6" gutterBottom>
          <strong>{Vocabulary.contractArticle3Title}</strong>
        </Typography>
        <Typography variant="body1" paragraph>
          {Vocabulary.contractArticle3Text
            .split("\n")
            .map((line: number, index: number) => (
              <React.Fragment key={index}>
                {line}
                {index <
                  Vocabulary.contractArticle3Text.split("\n").length - 1 && (
                    <br />
                  )}
              </React.Fragment>
            ))}
        </Typography>

        <Typography variant="h6" gutterBottom>
          <strong>{Vocabulary.contractArticle4Title}</strong>
        </Typography>
        <Typography variant="body1" paragraph>
          {Vocabulary.contractArticle4Text
            .split("\n")
            .map((line: number, index: number) => (
              <React.Fragment key={index}>
                {line}
                {index <
                  Vocabulary.contractArticle4Text.split("\n").length - 1 && (
                    <br />
                  )}
              </React.Fragment>
            ))}
        </Typography>

        <Typography variant="h6" gutterBottom>
          <strong>{Vocabulary.contractArticle5Title}</strong>
        </Typography>
        <Typography variant="body1" paragraph>
          {Vocabulary.contractArticle5Text
            .split("\n")
            .map((line: number, index: number) => (
              <React.Fragment key={index}>
                {line}
                {index <
                  Vocabulary.contractArticle5Text.split("\n").length - 1 && (
                    <br />
                  )}
              </React.Fragment>
            ))}
        </Typography>

        <Typography variant="h6" gutterBottom>
          <strong>{Vocabulary.contractArticle6Title}</strong>
        </Typography>
        <Typography variant="body1" paragraph>
          {Vocabulary.contractArticle6Text}
        </Typography>

        <Typography variant="h6" gutterBottom>
          <strong>{Vocabulary.contractArticle7Title}</strong>
        </Typography>
        <Typography variant="body1" paragraph>
          {Vocabulary.contractArticle7Text}
        </Typography>

        <Typography variant="h6" gutterBottom>
          <strong>{Vocabulary.contractArticle8Title}</strong>
        </Typography>
        <Typography variant="body1" paragraph>
          {Vocabulary.contractArticle8Text}
        </Typography>
      </Box>
    </>
  );
};
